export type InstitutionalHoldersChartDisplayMode = 'ownership' | 'activity';

export const INSTITUTIONAL_HOLDERS_CHART_DISPLAY_MODE_KEY =
  'institutionalHoldersChartDisplayMode';

export function readInstitutionalHoldersChartDisplayMode(): InstitutionalHoldersChartDisplayMode {
  if (typeof window === 'undefined') return 'activity';
  try {
    const raw = window.localStorage.getItem(INSTITUTIONAL_HOLDERS_CHART_DISPLAY_MODE_KEY);
    if (raw === 'ownership' || raw === 'activity') return raw;
  } catch {
    /* ignore */
  }
  return 'activity';
}

export function persistInstitutionalHoldersChartDisplayMode(
  mode: InstitutionalHoldersChartDisplayMode
): void {
  try {
    window.localStorage.setItem(INSTITUTIONAL_HOLDERS_CHART_DISPLAY_MODE_KEY, mode);
  } catch {
    /* ignore */
  }
}
